import { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';

import UsersService from '../../services/UsersService';

import { Button } from '@mui/material';
import Header from '../../components/Header/Header';
import ImagePicker from '../../components/ImagePicker/ImagePicker';
import UpdateAgentForm from '../../components/Forms/UpdateAgentForm/UpdateAgentForm';
import AgentUserDetailsCard from '../../components/AgentUserDetailsCard/AgentUserDetailsCard';
import RoundButton from '../../components/RoundButton/RoundButton';
import EditIcon from '@mui/icons-material/Edit';

import './Profile.scss';

function Profile() {
  const { authUser, isAuthorized, refreshCurrentUser } = useContext(AuthContext);
  const {showWarningMessage} = useContext(UIContext);

  const navigate = useNavigate();

  const [profilePicture, setProfilePicture] = useState(authUser?.user?.profile_picture?.url);

  const [isEditEnabled, setIsEditEnabled] = useState(false);

  const userId = authUser?.user?.id;
  const profilePictureId = authUser?.user?.profile_pic_id;
  const profilePictureUrl = profilePicture?.url || profilePicture;
  const name = authUser?.user?.first_name;
  const surname = authUser?.user?.last_name;
  const agentName = `${name} ${surname ? surname : ''}`;
  const phone = authUser?.user?.phone;

  const email = authUser?.user?.email;
  const city = authUser?.roles?.agent?.city?.name;
  const state = authUser?.roles?.agent?.city?.state?.state_code;

  const managerFirstName = authUser?.roles?.agent?.manager?.platform_user?.user?.first_name;
  const managerLastName = authUser?.roles?.agent?.manager?.platform_user?.user?.last_name;
  const manager = `${managerFirstName} ${managerLastName ? managerLastName : ''}`;
  const managerPictureURL = authUser?.roles?.agent?.manager?.platform_user?.user?.profile_picture?.url;

  const userService = new UsersService();

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  async function handleOnImgPicked(image) {
    try {
      authUser.user.profile_pic_id = image.id;
      authUser.user.profile_picture = image.url;

      if (!await userService.updateCurrentUser({
        userId: authUser.user.id,
        email: authUser.user.email,
        profilePicId: authUser.user.profile_pic_id,
        firstName: authUser.user.first_name,
        lastName: authUser.user.last_name,
        phone: authUser.user.phone
      })) {
        showWarningMessage({
          message: "Não foi possível atualizar a foto, tente novamente mais tarde"
        });
        return false;
      }

      setProfilePicture(authUser.user.profile_picture);
      return true;

    } catch (err) {
      showWarningMessage({
        message: "Não foi possível atualizar a foto, tente novamente mais tarde"
      });
    }
    return false;
  }

  async function handleSubmitUpdateAgentInfoForm({ name, surname, phone }, { setSubmitting }) {
    try {
      if (!await userService.updateAgentUser({
        agentUserId: authUser?.roles?.agent?.id,
        countryId: authUser?.roles?.agent?.city?.country_id,
        cityId: authUser?.roles?.agent?.city?.id,
        institutionId: authUser?.roles?.agent?.platform_user?.institution?.id,
        email: authUser?.user?.email,
        profilePicId: authUser?.user?.profile_pic_id,
        uidEmployerInstitution: authUser?.roles?.agent?.uid_on_employer_institution,
        firstName: name,
        lastName: surname,
        phone: phone
      })) {
        showWarningMessage({
          message: "Não foi possível atualizar suas informações básicas"
        });
        setSubmitting(false);
        setIsEditEnabled(false);
        return false;
      }

      setProfilePicture(authUser.user.profile_picture);

      await refreshCurrentUser();

      setSubmitting(false);
      setIsEditEnabled(false);
      return true;

    } catch (err) {
      showWarningMessage({
        message: "Não foi possível atualizar suas informações básicas"
      });
      setSubmitting(false);
    }
    setIsEditEnabled(false);
    return false;
  }

  function handleClickEditProfile() {
    setIsEditEnabled(true);
  }

  function handleCancelUpdate() {
    setIsEditEnabled(false);
  }

  return (
    <div className="inner-page profile-page">
      <Header
        showBackBtn
        hideBackBtnLabel
        pageTitle="Perfil"
      />
      <ImagePicker
        isProfile
        readOnly={!isEditEnabled}
        currentUserId={userId}
        pictureId={profilePictureId}
        image={profilePictureUrl}
        onUpdatedPickedImg={handleOnImgPicked}
        onImageUpdated={() => { }}
      />
      <div className="inner-page-content-container">
        {isEditEnabled ? (
          <div className="update-form-container">
            <UpdateAgentForm
              name={name}
              surname={surname}
              cpf={41234123}
              phone={phone}
              onSubmit={handleSubmitUpdateAgentInfoForm}
            />
            <Button
              onClick={handleCancelUpdate}
            >Cancelar</Button>
          </div>
        ) : (
          <AgentUserDetailsCard
            agentName={agentName}
            email={email}
            phone={phone}
            city={city}
            state={state}
            managerPictureURL={managerPictureURL}
            manager={manager}
          >
            {!isEditEnabled && (
              <RoundButton
                className="edit-profile-button"
                buttonIcon={<EditIcon />}
                handleOnClick={handleClickEditProfile}
              />
            )}
          </AgentUserDetailsCard>
        )}
      </div>
    </div>
  );
}

export default Profile;
